import service from './service'

class UserService {
    entity = 'users'

    getAll () {
      return service.get(`/${this.entity}`)
    }

    get (id) {
      return service.get(`/${this.entity}/${id}`)
    }

    create (data) {
      return service.post(`/${this.entity}`, data)
    }

    getRoles () {
      return service.get(`/${this.entity}/roles`)
    }

    update(id, data) {
      return service.put(`/${this.entity}/${id}`, data);
    }

}

export default new UserService()






































